import React from 'react';
import { Form } from 'react-form';
import Popup from '../../components/Popup';
import {
    Textarea,
} from '../../components/Form';

const ReportPopup = props => {
    const {
        onCloseClick,
        onSendClick,
        reportPending,
        reportSuccess,
        reportError,
        'data-testid': dataTestId,
    } = props;

    return (
        <Popup
            className="popup-md"
            onCloseClick={onCloseClick}
            config={{
                noPadding: false,
                fullScreen: false,
                topGradient: true,
                style: {
                    height: 470,
                    maxHeight: '100%',
                },
            }}
        >
            {!reportSuccess ? (
                <Form onSubmit={values => onSendClick({ values })}>
                    {({ submitForm }) => {
                        return (
                            <form onSubmit={submitForm} id="reportConversationForm" data-testid={dataTestId}>
                                <div className="container">
                                    <div className="row">
                                        <div className="col-12">
                                            <h5 className={`text-uppercase`} data-testid={dataTestId ? `${dataTestId}.title` : undefined}>Report this conversation</h5>
                                        </div>
                                        <div className="col-12 mt16">
                                            <Textarea
                                                description="Please let us know if you found this conversation inappropriate or offensive. We will review and get back to you within 2-3 business days."
                                                id="notes"
                                                field="notes"
                                                rows="5"
                                                placeholder="Please add notes for the team"
                                                data-testid={dataTestId ? `${dataTestId}.notes-input` : undefined}
                                            />
                                        </div>
                                        {reportError && (
                                            <div className="col-12 mb4 text-error text-center" data-testid={dataTestId ? `${dataTestId}.error` : undefined}>
                                                Error sending report.
                                            </div>
                                        )}
                                        <div className="col-12 mt8">
                                            <button
                                                type="submit"
                                                className="btn btn-primary btn-xl text-uppercase btn-block"
                                                data-testid={dataTestId ? `${dataTestId}.send-btn` : undefined}
                                            >
                                                {!reportPending ? <span>Send Report</span> : <span><i className="fas fa-circle-notch fa-spin" /> Sending Report...</span>}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        );
                    }}
                </Form>
            ) : (
                <div className="container" data-testid={dataTestId ? `${dataTestId}.success-view` : undefined}>
                    <div className="row">
                        <div className="col-12">
                            <h5 className={`text-uppercase`} data-testid={dataTestId ? `${dataTestId}.success-title` : undefined}>Report this conversation</h5>
                        </div>
                        <div className="col-12 mt16 report-submitted-text" data-testid={dataTestId ? `${dataTestId}.success-message` : undefined}>
                            Report submitted.
                        </div>
                        <div className="col-12 mt8">
                            <button
                                type="button"
                                className="btn btn-default btn-xl text-uppercase btn-block"
                                onClick={onCloseClick}
                                data-testid={dataTestId ? `${dataTestId}.close-btn` : undefined}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </Popup>
    );
};

export default ReportPopup;
